import PageTemplate from "../components/PageTemplate";
import PageFade from "../motions/PageFade";

function RSVP() {
    return (
        <PageFade>
            <PageTemplate title="Page Not Found">
                <div className="text-center">
                    <p>Please use the menu to navigate back to the website.</p>
                </div>
            </PageTemplate>
        </PageFade>
    );
}

export default RSVP;
